import { Component, input, output, signal } from "@angular/core";
import { InvoiceDropdowns, PurchaseOrderForVendor, PurchaseRequisitionForVendor } from "./InvoiceDropdowns";
import { MatFormFieldModule } from "@angular/material/form-field";
import { MatSelectModule } from "@angular/material/select";
import { FormsModule } from "@angular/forms";
import { MatOptionModule } from "@angular/material/core";

@Component({
  selector: 'invoice-filter',
  templateUrl: 'invoice-filters.component.html',
  standalone: true,
  imports: [FormsModule, MatFormFieldModule, MatSelectModule, MatOptionModule]
})
export class InvoiceFilterComponent {
  protected Year: number;
  protected PurchaseOrderNumber: string;
  protected PurchaseRequisitionNumber: string;

  public VendorId = input.required<number>();

  public ValuesRequired = input<boolean>(false);
  public PurchaseRequisitionSelected = output<string>();
  public PurchaseOrderSelected = output<string>();
  public YearSelected = output<number>();

  protected Dropdowns = {
    Years: signal<number[]>([]),
    PurchaseOrders: signal<PurchaseOrderForVendor[]>([]),
    PurchaseRequisitions: signal<PurchaseRequisitionForVendor[]>([]),
  }

  SetDropdowns(dropdowns: InvoiceDropdowns) {
    this.Dropdowns.PurchaseOrders.set(dropdowns.PurchaseOrdersForVendor);
    this.Dropdowns.PurchaseRequisitions.set(dropdowns.PurchaseRequisitionsForVendor);
    this.Dropdowns.Years.set(dropdowns.Years);
  }

  protected onYearSelected(year: number) {
    this.PurchaseOrderNumber = null;
    this.PurchaseRequisitionNumber = null;
    this.YearSelected.emit(year);
  }

  protected onPurchaseOrderNumberSelected(poNumber: string) {
    this.PurchaseOrderSelected.emit(poNumber);
  }

  protected onPurchaseRequisitionSelected(prNumber: string) {
    this.PurchaseRequisitionSelected.emit(prNumber);
  }
}
